import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import moment from 'moment';
import styles from './date.module.scss';

const createDateCell =
  (format: string = 'MMM DD, YYYY') =>
  ({ value }: Partial<ICellRendererParams>) => {
    return <span className={styles.date}>{moment(value).format(format)}</span>;
  };

const DateCell = createDateCell();

export { createDateCell, DateCell };
